export default __webpack_public_path__ + "static/0237-9ab8d2170dd4f5b7cee64804c712c660.png";